import { Box, Stack, Typography, useMediaQuery } from '@mui/material'
import { BackButtonLink } from '../../../presentation-components/display-elements-components/back-button-link'
import { useParams } from 'react-router-dom';
import xero from '../../../../assets/images/xero.png'
import quickbook from "../../../../assets/images/quickbook.png";
import sage from "../../../../assets/images/sage.png";
import businessCentral from "../../../../assets/images/businesscentral.svg";
import gaiaTheme from '../../../../root-components/theme';
import { Details } from '../../../../modules/third-party-connection/shared-components/components/details';
import { CloudProviderLogo } from '../../../../modules/third-party-connection/cloud-components/cloud-provider-logo';
import { CloudEmissionsDetails } from '../../../../modules/third-party-connection/cloud-components/cloud-emissions-details';
import { BusinessCentralDetails } from '../../../../modules/third-party-connection/business-central-components/business-central-details';
import { CLOUD_PROVIDER_NAMES, isCloudEmissionsProvider } from '../../../../modules/third-party-connection/shared-services/cloud-emissions/cloud-emissions.model';

export const ThirdPartyDetailsPage = () => {
  const { id } = useParams();
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('md'));

  return (
    <>
      {id &&
        <Box sx={{ display: 'flex', flexDirection: 'column', pt: isMobileMode ? 2 : 4, pb: isMobileMode ? 2 : 6, pl: isMobileMode ? 2 : 6, pr: isMobileMode ? 2 : 6, mt: isMobileMode ? 5 : 0 }}>
          <Stack display='flex' justifyContent='flex-start' sx={{ mb: 4 }}>
            <BackButtonLink buttonText={'Back to integrations'} link={'/settings/integrations'} />
            <Stack display='flex' direction='row' justifyContent='space-between' alignItems='center' sx={{ mt: 1 }}>
              <Stack display='flex' alignItems='center' direction='row' gap={2}>
                {id === 'xero' && <img src={xero} alt="xero" width='100rem' />}
                {id === 'quickbooks' && <img src={quickbook} alt="quickbook" width='100rem' />}
                {id === 'sage' && <img src={sage} alt="sage" width='100rem' />}
                {id === 'sage200' && <img src={sage} alt="sage 200" width='100rem' />}
                {isCloudEmissionsProvider(id) && <CloudProviderLogo provider={id} size={48} />}
                {isCloudEmissionsProvider(id) && <Typography variant='h4' sx={{ color: 'text.primary', mt: 1 }}>{CLOUD_PROVIDER_NAMES[id]}</Typography>}
                {id !== 'sage' && id !== 'sage200' && id !== 'businesscentral' && !isCloudEmissionsProvider(id) && <Typography variant='h4' sx={{ color: 'text.primary', mt: 1 }}>{id.charAt(0).toUpperCase() + id.slice(1).toLowerCase()}</Typography>}
                {id === 'sage' && <Typography variant='h4' sx={{ color: 'text.primary', mt: 1 }}>Sage Accounting</Typography>}
                {id === 'sage200' && <Typography variant='h4' sx={{ color: 'text.primary', mt: 1 }}>Sage 200 Standard</Typography>}
                {id === 'businesscentral' && <img src={businessCentral} alt="business central" width='160rem' />}
                {id === 'businesscentral' && <Typography variant='h4' sx={{ color: 'text.primary', mt: 1 }}>Business Central</Typography>}
              </Stack>
            </Stack>
          </Stack>
          {isCloudEmissionsProvider(id)
              ? <CloudEmissionsDetails provider={id} />
              : id === 'businesscentral'
                ? <BusinessCentralDetails />
                : <Details provider={id} />}
        </Box>
      }
    </>
  )
}